import styled from 'styled-components';
import { COLOR_BRAND_GRADIENT } from 'styles/variables/colors';

export const Container = styled.div`
  background: ${COLOR_BRAND_GRADIENT};
  width: 100%;
`;
